import { useRef } from 'react';
import { ItemTreeContext } from './ItemTreeContext.js';
import { jsx } from 'react/jsx-runtime';

function ItemTree(_ref) {
  let {
    children,
    items: {
      UNSAFE_collectionRef: collectionRef,
      UNSAFE_setCollection: setCollection
    }
  } = _ref;
  const indexRef = useRef(0);
  const context = {
    parentList: collectionRef.current,
    indexRef,
    onUpdate: () => {
      setCollection(() => [...collectionRef.current]);
    }
  };
  indexRef.current = 0;
  return /*#__PURE__*/jsx(ItemTreeContext.Provider, {
    value: context,
    children: children
  });
}

export { ItemTree };
